/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Signed_In_AsInputs */

const en_mobile_signed_in_as = /** @type {(inputs: Mobile_Signed_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed in as`)
};

const es_mobile_signed_in_as = /** @type {(inputs: Mobile_Signed_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesión iniciada como`)
};

/**
* | output |
* | --- |
* | "Signed in as" |
*
* @param {Mobile_Signed_In_AsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_signed_in_as = /** @type {((inputs?: Mobile_Signed_In_AsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Signed_In_AsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_signed_in_as(inputs)
	return en_mobile_signed_in_as(inputs)
});